import { Link } from "react-router-dom";
// import CustomSlider from "../Common/CustomSlider";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

// import Swiper core and required modules
import { Autoplay, Navigation, Pagination } from 'swiper';

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";

// Import Swiper styles
import "swiper/swiper-bundle.min.css";
import "swiper/modules/navigation/navigation.min.css";
import "swiper/modules/pagination/pagination.min.css";

import { isMobile } from "react-device-detect";

function Accessories({ heading, componentData, getTargetUrl, showShopNow=false }) {
  
  const navigation_status = isMobile? false:true;  
  const slide_per_view = isMobile?2:3;
  return (
    <>    
    <section className="accessories-section">
          <div className="us-section-heading-area">
            <h2 className="us-heading">Accessories Collection</h2>
            <p className="us-subheading">
              Adorn yourself with timeless finishing touches to stay in the spotlight
            </p>
          </div>
          <div className="us-accessories-cards-wrapper">
            <Swiper
              slidesPerView={5}
              spaceBetween={20}
              centeredSlides={false}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              loop={true}
              modules={[Autoplay, Pagination, Navigation]}
              className="mySwiper"
              breakpoints={{
                // when window width is >= 320px
                320: {
                  slidesPerView: 2,
                },
                // when window width is >= 565px
                565: {
                  slidesPerView: 3,
                },
                // when window width is >= 992px
                992: {
                  slidesPerView: 5,
                },
              }}
            >              
          {componentData.data?.map((data, index) => {
            return (            
              <SwiperSlide key={"accessories" + index}>
              <Link to={getTargetUrl(data)} className="us-accessories-card">
                <div className="img-area">                
                  <LazyLoadImage
                      alt={""}
                      effect="blur"
                      src={data.src || ""}
                      // className="img-fluid mx-auto d-block"
                      // style={{height: isMobile?"":"500px"}}
                    />
                </div>
                <div className="content-area">
                  <h2 className="title">{data?.title || ""}</h2>
                </div>
              </Link>
            </SwiperSlide>        
            );
          })}              
            </Swiper>
          </div>
        </section>
    </>
  );
}

export default Accessories;
